module.exports = __webpack_public_path__ + "static/img/red_bg.c95750f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_bg.png
// module id = 1dx6
// module chunks = 1